import { GV_EXTRA_PARAMS } from '../utils/enum';
import { isWebGa } from './utils';

export const avoidChecks = (key) => {
  return GV_EXTRA_PARAMS[key];
};

export const eventsKeysCompare = (data, key) => {
  const isExtra = avoidChecks(key);
  if (isExtra) return true;
  return esChecks(data, key);
};

export const esChecks = (data, key) => {
  const { ga, gv } = data;
  if (!gv || !ga) return false;
  let isWeb = isWebGa();

  const params = isWeb ? ga : ga.events[0].params;

  if (key === 'event_category' || key === 'eventCategory') {
    return params.eventCategory === gv.event_category;
  }
  if (key === 'TimeStamp') {
    return gv.event_data.TimeStamp === ga.user_properties.TimeStamp.value;
  }
  if (key === 'name' || key === 'event' || key === 'event_name') {
    return isWeb
      ? params.event === gv.event_name
      : ga.events[0].name === gv.event_name;
  }
  return false;
};
